var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLesson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28571 0C1.91964 0 0 1.67969 0 3.75V16.25C0 18.3203 1.91964 20 4.28571 20H17.1429H18.5714C19.3616 20 20 19.4414 20 18.75C20 18.0586 19.3616 17.5 18.5714 17.5V15C19.3616 15 20 14.4414 20 13.75V1.25C20 0.558594 19.3616 0 18.5714 0H17.1429H4.28571ZM4.28571 15H15.7143V17.5H4.28571C3.49554 17.5 2.85714 16.9414 2.85714 16.25C2.85714 15.5586 3.49554 15 4.28571 15ZM5.71429 5.625C5.71429 5.28125 6.03571 5 6.42857 5H15C15.3929 5 15.7143 5.28125 15.7143 5.625C15.7143 5.96875 15.3929 6.25 15 6.25H6.42857C6.03571 6.25 5.71429 5.96875 5.71429 5.625ZM6.42857 7.5H15C15.3929 7.5 15.7143 7.78125 15.7143 8.125C15.7143 8.46875 15.3929 8.75 15 8.75H6.42857C6.03571 8.75 5.71429 8.46875 5.71429 8.125C5.71429 7.78125 6.03571 7.5 6.42857 7.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLesson);
export default __webpack_public_path__ + "static/media/lesson.f60e755ef4e70b2650627ef3bfefc9e3.svg";
export { ForwardRef as ReactComponent };